import { render, staticRenderFns } from "./modalEntregasDias.vue?vue&type=template&id=23bb2f4d&scoped=true"
import script from "./modalEntregasDias.vue?vue&type=script&lang=js"
export * from "./modalEntregasDias.vue?vue&type=script&lang=js"
import style0 from "./modalEntregasDias.vue?vue&type=style&index=0&id=23bb2f4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bb2f4d",
  null
  
)

export default component.exports